/* eslint-disable class-methods-use-this */
import http from './httpService';

class TokenAuthService {
  async authenticate(authenticationInput) {
    const result = await http.post(
      'api/TokenAuth/Authenticate',
      authenticationInput
    );
    return result.data.result;
  }

  async impersonateSignIn(tokenId) {
    const result = await http.get('api/TokenAuth/ImpersonateSignIn', {
      params: { id: tokenId },
    });

    return result.data.result;
  }

  async impersonate(input) {
    const result = await http.get('api/TokenAuth/Impersonate', {
      params: input,
    });

    return result.data;
  }

  async backToImpersonator() {
    const result = await http.get('api/TokenAuth/BackToImpersonator');

    return result.data;
  }
}

export default TokenAuthService = new TokenAuthService();
